import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAfrondingTechniek = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="M15.81 6.05a7 7 0 0 1 1.82 6.73l9.54 9.54a7 7 0 0 1 8.55 8.54l-4.28-4.27-4.9 4.91 4.27 4.27a7 7 0 0 1-8.54-8.55l-9.54-9.54a7 7 0 0 1-8.55-8.54l4.27 4.27 4.91-4.91-4.27-4.27a7 7 0 0 1 6.72 1.82"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m13.874 28.87 7.806-16.917 4.54 2.094-10.16 22.02-4.568-.062-5.88-13.72 4.596-1.97z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m9.559 34.02-3.01-6.968-.918.396 3.27 7.572h4.849v-1z"
      clipRule="evenodd"
    />
    <path
      fill="#15265A"
      fillRule="evenodd"
      d="M32.21 21.91a7.81 7.81 0 0 0-7.188.516l-.524-.852a8.81 8.81 0 0 1 13.242 5.725l-.98.202a7.81 7.81 0 0 0-4.55-5.59"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAfrondingTechniek);

export default ForwardRef;
